import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useSettings } from '../contexts/SettingsContext';

const WhatsAppButton = () => {
  const { settings } = useSettings();
  const whatsappLink = settings?.whatsappGroupLink || 'https://chat.whatsapp.com/DPOHOoryJGJ86VHcE8pgMC';

  return (
    <div className="whatsapp-floating-button">
      <a 
        href={whatsappLink} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="whatsapp-floating-link"
        title="Join our WhatsApp group for food ordering"
      >
        <FaWhatsapp size={24} />
        <span className="whatsapp-tooltip">Join WhatsApp Group</span>
      </a>
    </div>
  );
};

export default WhatsAppButton; 